const zh_exclusive = {
  'flame'  : '【火】',
  'water'  : '【水】',
  'wind'   : '【風】',
  'light'  : '【光】',
  'shadow' : '【闇】',
  'sword'  : '【劍】',
  'blade'  : '【刀】',
  'dagger' : '【短劍】',
  'axe'    : '【斧】',
  'lance'  : '【槍】',
  'bow'    : '【弓】',
  'wand'   : '【魔杖】',
  'staff'  : '【法杖】',
}

export default zh_exclusive